/* eslint-disable import/no-default-export */
import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { HeaderTestIds } from '@trello/webdriverio-tests';
import { IconName } from 'app/common/components/controls/icon';
import { CreateMenuPopoverId } from 'app/gamma/src/components/popovers/popover-ids';
import { showPopover, State } from 'app/gamma/src/modules';
import { isPopoverShown } from 'app/gamma/src/selectors/popovers';

import { Noun, Verb, trackUe } from '@trello/analytics';
import HeaderButton from './button';

const HeaderCreateMenuPopoverPromise = import(/* webpackChunkName: "create-menu-popover" */ 'app/gamma/src/components/popovers/header-create-menu');
const HeaderCreateMenuPopover = lazy(() => HeaderCreateMenuPopoverPromise);

interface StateProps {
  isActive: boolean;
}

interface DispatchProps {
  onClick: React.MouseEventHandler;
}

type AllProps = StateProps & DispatchProps;

class CreateMenuButton extends React.Component<AllProps> {
  createMenuButtonRef = React.createRef<HTMLButtonElement>();

  render() {
    const { isActive, onClick } = this.props;

    return (
      <>
        <HeaderButton
          icon={IconName.Add}
          onClick={onClick}
          ref={this.createMenuButtonRef}
          testId={HeaderTestIds.CreateMenuButton}
        />
        {isActive && (
          <Suspense fallback={null}>
            <HeaderCreateMenuPopover
              target={() => this.createMenuButtonRef.current}
            />
          </Suspense>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: State): StateProps => {
  return {
    isActive: isPopoverShown(state, CreateMenuPopoverId),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<State>): DispatchProps => {
  return {
    onClick() {
      trackUe({
        category: Noun.HEADER,
        verb: Verb.OPENS,
        directObj: Noun.ADD_MENU,
        method: 'by clicking header add menu button',
      });

      dispatch(showPopover({ name: CreateMenuPopoverId }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateMenuButton);
